class TooltipController {
    constructor() {
    }
}
class tooltipDirective {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.restrict = 'A';
        this.scope = true;
        this.controller = TooltipController;
        this.controllerAs = 'tooltipCtrl';
        this.bindToController = {
        };
    }

    link(scope, element, attrs) {
        let width = element.width(), timeoutEv;
        let positionDown = attrs.hasOwnProperty('tooltipInfoDown');
        let cssClass = attrs.hasOwnProperty('tooltipEllipsis') || attrs.hasOwnProperty('tooltipInfo') || attrs.hasOwnProperty('tooltipInfoDown') ? 'tooltip-info-layout' : 'tooltip-data-layout' || positionDown ? 'tooltip-info-layout' : 'tooltip-data-layout';
        let upDownClass = positionDown ? 'tooltip-down' : 'tooltip-up';
        let alwaysShowTooltip = attrs.hasOwnProperty('alwaysShow') && attrs.alwaysShow.length > 0;
        let customYOffset = attrs.customYOffset || 0;
        let customTopOffset = attrs.customTopOffset || 5;
        element.hover(
            (event) => {

                if (timeoutEv) {
                    this.$timeout.cancel(timeoutEv);
                    timeoutEv = null;
                }
                timeoutEv = this.$timeout(() => {
                    let text = attrs.tooltipData || attrs.tooltipInfo || attrs.tooltipEllipsis || attrs.tooltipInfoDown,
                        infoCondition = (attrs.hasOwnProperty('tooltipInfo') || attrs.hasOwnProperty('tooltipInfoDown')) && text,
                        ellipsisCondition = attrs.hasOwnProperty('tooltipData') && text,
                        dataCondition = attrs.hasOwnProperty('tooltipEllipsis') && element[0].scrollWidth > Math.ceil(element.outerWidth());
                    if (alwaysShowTooltip && !dataCondition) {
                        text = '';
                    }

                    if (infoCondition || dataCondition || ellipsisCondition || alwaysShowTooltip) {
                        var tooltipDiv = document.createElement("div");
                        tooltipDiv.id = 'tooltip_div';
                        tooltipDiv.innerHTML = `<span class="${cssClass} ${upDownClass} tooltip-layout-class" style="white-space: pre-line !important;">${text + (alwaysShowTooltip ? (dataCondition ? '\n' + '\n' : '') + attrs.alwaysShow : '')}</span>`;
                        document.body.appendChild(tooltipDiv);
                        let bodyClientRect = document.body.getBoundingClientRect(),
                            bodyXOffsetWidth = bodyClientRect ? (bodyClientRect.width + bodyClientRect.left) : null,
                            tooltip = $(document.body).find(`.${cssClass}`),
                            element_outerWidth = element.outerWidth(),
                            element_offsetLeft = element.offset().left,
                            tooltip_outerWidth = tooltip.outerWidth(),
                            tooltip_offsetLeft = tooltip.offset().left,
                            // default left tooltip position: centered above the hover element
                            xOffset = element_offsetLeft + element_outerWidth / 2 - (tooltip_offsetLeft + tooltip_outerWidth / 2),
                            yPosition = positionDown ? tooltip.outerHeight() + parseInt(customYOffset) : -tooltip.outerHeight() - parseInt(customTopOffset),
                            yOffset = element.offset().top - tooltip.offset().top + yPosition;
                        if (bodyXOffsetWidth !== null) {
                            // reset left tooltip position if tooltip is cut on screen left side
                            if (xOffset < 0) {
                                xOffset = element_offsetLeft + bodyClientRect.left;
                                tooltip.addClass("tooltip-start-layout");
                            }
                            // reset left tooltip position if tooltip is cut on screen right side
                            else if ((xOffset + tooltip_outerWidth) > bodyXOffsetWidth) {
                                xOffset = (element_offsetLeft + element_outerWidth) - (tooltip_offsetLeft + tooltip_outerWidth);
                                tooltip.addClass("tooltip-end-layout");
                            } else {
                                tooltip.removeClass("tooltip-start-layout");
                                tooltip.removeClass("tooltip-end-layout");
                            }
                        }

                        if (tooltip && tooltip[0]) {
                            $(document.body).find(`.${cssClass}`).css('transform', `translate(${xOffset}px,${yOffset}px`);
                            $(document.body).find(`.${cssClass}`).css('visibility', 'visible');
                        } else {
                            this.$timeout.cancel(timeoutEv);
                            timeoutEv = null;
                        }
                    }
                }, 150, false);
            },
            () => {
                removeTooltip();
            }
        );

        scope.$on("$destroy", () => {
            removeTooltip();
        });
        let removeTooltip = () => {
            let tooltipEl = $(document.body).find(`#tooltip_div`);
            if (tooltipEl && tooltipEl[0]) tooltipEl.remove();
            this.$timeout.cancel(timeoutEv);
            timeoutEv = null;
        };
    }

    static directiveFactory($timeout) {
        return new tooltipDirective($timeout);
    }
}

tooltipDirective.directiveFactory.$inject = ['$timeout'];

module.exports = tooltipDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/utils/tooltip.directive.js